import { useEffect } from 'react';
import styled from 'styled-components';
import { MobileBottomSheet, PopupCloseControl } from '@elfsight/widget-modal';
import { createReadableClass } from '@elfsight/widget-utils';
import {
  CheckoutPayment,
  CheckoutSummary,
  useCheckoutColors,
  useCheckoutNavigation
} from '../components';
import { BACKDROP_COLOR, COMPONENT_NAME } from './constants';
import type { CheckoutComponentLayoutDistilledProps } from './types';

export function NarrowLayout({
  paymentComponentProps,
  summaryComponentProps
}: CheckoutComponentLayoutDistilledProps) {
  const { isSummaryOpen, closeSummary, resetCheckoutStep } =
    useCheckoutNavigation();
  const { backgroundColor, textColor70A } = useCheckoutColors();

  useEffect(() => {
    resetCheckoutStep();
  }, []);

  return (
    <NarrowBackground $backgroundColor={backgroundColor}>
      <NarrowContent $classModifier="payment">
        <CheckoutPayment {...paymentComponentProps} />
      </NarrowContent>

      <MobileBottomSheet
        open={isSummaryOpen}
        onCloseRequest={closeSummary}
        backdropBackgroundColor={BACKDROP_COLOR}
        height="calc(100% - 40px)"
      >
        <NarrowBackground $backgroundColor={backgroundColor}>
          <MobileSummaryCloseButtonPivot>
            <PopupCloseControl onClick={closeSummary} color={textColor70A} />
          </MobileSummaryCloseButtonPivot>
          <NarrowContent $classModifier="summary">
            <CheckoutSummary {...summaryComponentProps} />
          </NarrowContent>
        </NarrowBackground>
      </MobileBottomSheet>
    </NarrowBackground>
  );
}

const NarrowBackground = styled.div.attrs<{
  $backgroundColor: string;
}>({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'background-narrow'
  })
})`
  position: relative;

  display: flex;
  justify-content: center;

  min-height: 100%;
  height: 100%;
  min-width: 100%;
  width: 100%;

  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

const NarrowContent = styled.div.attrs<{ $classModifier: string }>(
  ({ $classModifier }) => ({
    className: createReadableClass({
      component: COMPONENT_NAME,
      element: 'content-narrow',
      modifier: $classModifier
    })
  })
)`
  width: 100%;
`;

const MobileSummaryCloseButtonPivot = styled.div.attrs({
  className: createReadableClass({
    component: COMPONENT_NAME,
    element: 'summary-close-button-pivot'
  })
})`
  position: absolute;
  top: 12px;
  right: 12px;
`;
